module.exports = __webpack_public_path__ + "static/media/new_order.0f125292.svg";